const DEFAULT_THRESHOLD = 50;
const DEFAULT_CADENCE = 'DAILY';
const makeDefaultNotificationConfigsMap = () => {
  return {
    ENROLLMENT_DIGEST: {
      type: 'ENROLLMENT_DIGEST',
      rule: {
        notificationType: 'ENROLLMENT_DIGEST',
        increaseThresholdPercentage: DEFAULT_THRESHOLD,
        decreaseThresholdPercentage: DEFAULT_THRESHOLD,
        notificationCadence: DEFAULT_CADENCE
      },
      isEnabled: false
    },
    ISSUE_NOTIFICATION: {
      type: 'ISSUE_NOTIFICATION',
      rule: {
        notificationType: 'ISSUE_NOTIFICATION'
      },
      isEnabled: false
    },
    AI_BASED_ENROLLMENT_DIGEST: {
      type: 'AI_BASED_ENROLLMENT_DIGEST',
      rule: {
        notificationType: 'AI_BASED_ENROLLMENT_DIGEST',
        notificationCadence: DEFAULT_CADENCE
      },
      isEnabled: false
    }
  };
};
export default makeDefaultNotificationConfigsMap;